import {
  Component,
  ChangeDetectionStrategy,
  input,
  output,
} from '@angular/core';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { lucideImage, lucideBox, lucideCheck } from '@ng-icons/lucide';
import { AnalysisType } from '@shared/models/analysis.model';

/**
 * Prospective analysis-type picker — the 2D/3D choice offered when a run starts at
 * geocut and the analysis file does not exist yet (geocut produces it).
 *
 * Presentational: it renders the choice and emits it. Assigning the type to an
 * analysis stays with the caller, because the call differs per context — a single
 * analysis PATCHes it, a campaign run applies it per batch at dispatch.
 *
 * Extracted from ExecutionPanel's prospective block so the campaign panel and the
 * create-analysis dialog cannot drift apart visually or behaviourally.
 */
@Component({
  selector: 'app-analysis-type-picker',
  standalone: true,
  imports: [NgIconComponent],
  providers: [provideIcons({ lucideImage, lucideBox, lucideCheck })],
  templateUrl: './analysis-type-picker.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnalysisTypePicker {
  selected = input<AnalysisType | null>(null);
  /** Show the "Ausgewählt" confirmation pill — off until the choice is actually applied. */
  showAppliedBadge = input<boolean>(true);
  disabled = input<boolean>(false);

  typeSelected = output<AnalysisType>();

  select(type: AnalysisType): void {
    if (this.disabled()) return;
    this.typeSelected.emit(type);
  }
}
